import * as React from "react";
import CreateNewCode from "./CreateNewCode";
import { Box, Grid } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createCodeApi } from "../../../../../services/marketingApi";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";

export default function NewCode() {
  const createUserMarketingCode = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const response = await createCodeApi(data)
      const resData = checkResponseData(response);
      if(resData["success"]){
      toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false,autoClose:3000 });
      }else{
      toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false,autoClose:3000 });
      }      
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg=errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false,autoClose:3000 });
            console.error(error);
    }
  };

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Box sx={{ width: "100%", px: 1 }}>
        <CreateNewCode createUserMarketingCode={createUserMarketingCode} />
      </Box>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </Grid>
  );
}
